import RightsListGen from "../../components/RightsListGen";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
  selectedRightCategory: state.rights.selectedRightCategory,
  selectedSubright: state.rights.selectedSubright,
  isRightsLoading: state.rights.isRightsLoading,
  isSubrightsLoading: state.rights.isSubrightsLoading,
  isLearnMoresLoading: state.rights.isLearnMoresLoading,
});

export default connect(mapStateToProps, null)(RightsListGen);
